import type { ILpElementLink, ILpElementSimpleList } from '../declarations/contentful';

/**
 * Type guard to check if an item is a simple link (ILpElementLink) or a list (ILpElementSimpleList)
 */
export function isSimpleLink(item: ILpElementLink | ILpElementSimpleList): item is ILpElementLink {
  return item?.fields != null && 'text' in item.fields && 'url' in item.fields;
}
